import React from 'react';
import { Paragraph } from '../../../components/paragraph';
import { Toggle } from '../../../components/toggle';
import { RadioButtonGroup } from '../../../components/radio-button-group';

const AccessibilitySettings = props => {
    const { fontSize, setFontSize, timedGames, setTimedGames } = props;

    const timedGamestext = `Timed Games: ${timedGames === true ? 'On' : 'Off'}`;

    return (
        <>
            <div className="settings-page__font-size-menu">
                <Paragraph
                    withSpacing={false}
                    textAlign="center"
                    colorScheme="dark"
                >
                    Font Size
                </Paragraph>
                <RadioButtonGroup
                    options={[
                        { label: 'medium' },
                        { label: 'large' },
                        { label: 'x-large' },
                    ]}
                    checked={fontSize}
                    group="font-size"
                    onChange={e => setFontSize(e.currentTarget.value)}
                />
            </div>
            <div className="settings-page__button">
                <Toggle
                    text={timedGamestext}
                    value={timedGames}
                    onChange={() => setTimedGames(!timedGames)}
                />
            </div>
        </>
    );
};

export { AccessibilitySettings };
